const DB_NAME = 'ek-upload-blobs';
const STORE_NAME = 'blobs';
const DB_VERSION = 1;

function openDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = () => {
      request.result.createObjectStore(STORE_NAME);
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function putBlob(key: string, blob: Blob): Promise<void> {
  const db = await openDb();

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    tx.objectStore(STORE_NAME).put(blob, key);

    tx.oncomplete = () => {
      db.close(); resolve(); 
    };

    tx.onerror = () => {
      db.close(); reject(tx.error); 
    };
  });
}

export async function getBlob(key: string): Promise<Blob | undefined> {
  const db = await openDb();

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readonly');
    const req = tx.objectStore(STORE_NAME).get(key);

    req.onsuccess = () => {
      db.close(); resolve(req.result ?? undefined); 
    };

    req.onerror = () => {
      db.close(); reject(req.error); 
    };
  });
}

export async function deleteBlob(key: string): Promise<void> {
  const db = await openDb();

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    tx.objectStore(STORE_NAME).delete(key);

    tx.oncomplete = () => {
      db.close(); resolve(); 
    };

    tx.onerror = () => {
      db.close(); reject(tx.error); 
    };
  });
}
